import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment-timezone";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { getTimezones } from "../../services/uidata";
import { filterVisibleTimeZones } from "../../utils/helpers";

//css
import "./checktimezone.css";
import { updateNewTimeZone } from "../../services/profile";
import { setUser } from "../../reducer/userSlice";
import { fetchUser } from "../../services/auth";


export default function CountryTimeZoneSelection({ newTimezoneData = [], confirmNewTimeZone, disableTime, CurrentDate ,countryName }) {
    //states
    // const navigate = useNavigate();
    const dispatch = useDispatch()

    const [value, setValue] = useState("");
    const [error, setError] = useState(false);
    const [step, setStep] = useState(false);
    const [timezoneValue, setTimeZoneValue] = useState('');


    useEffect(() => {
        if (newTimezoneData.length > 0) {

            setTimeZoneValue(newTimezoneData[0].front_name);
        }
    }, [newTimezoneData])
    const changeHandler = (e) => {
        setError(false)
        setValue(e.target.value);
        setshowRequiredError(false)
        changeTimeZone(e.target.value)
    }

    const submitHandler = () => {
        setshowRequiredError(true)
        if (value !== "" && timeconfirmcheck) {
            confirmNewTimeZone(value)
        }
        else {
            if (value == "") setError(true)


        }
    }
    useEffect(() => {
        setCurrentDates(CurrentDate);
    }, [CurrentDate])
    const [CurrentDates, setCurrentDates] = useState(CurrentDate)
    const [timeconfirmcheck, settimeconfirmcheck] = useState(false)
    const [showRequiredError, setshowRequiredError] = useState(false);
    const changeTimeZone = (value) => {
        // setFieldValue("timezone", value)
        let filter = newTimezoneData.filter((item) => item.id == value);
        setCurrentDates(moment().tz(filter[0].name).format('hh:mm A'))
    }
    const confirmTime = () => {
        confirmNewTimeZone(newTimezoneData[0].id);
    }
    return (
        <div
            className="modal fade mt-5"
            id="CountryTimeZoneSelection"
            data-backdrop="static"
            role="dialog"
        >
            <div className="modal-dialog  modal-dialog-preview-new">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="schedule-popup">
                            {/* <img src="../images/new-cll.png" alt="user" /> */}

                            <h4 className="">
                                {step ? <>We would like to change your time zone to {timezoneValue}. <br />Is this correct?
                                </> :

                                    <>You’ve indicated that you are in {countryName}. Can you please reconfirm your timezone?</>}
                                <br />
                            </h4>
                            {step ?
                                <>
                                    <br />
                                    <br />
                                    <br />
                                    <div className="d-flex align-items-center justify-content-around">

                                        <div
                                            // onClick={() => setStep(false)}

                                            className="width-215-px white-border pointer indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4  d-flex align-items-center justify-content-center"
                                        >
                                            No
                                        </div>
                                        <div
                                            onClick={confirmTime}
                                            className="width-215-px white-bg-btn pointer indexstyles__StyledButton-sc-83qv1q-0 jdbotF sc-1qeub3n-4  d-flex align-items-center justify-content-center"
                                        >
                                            Yes
                                        </div>

                                    </div>

                                    <br />
                                    <br />
                                </>
                                :
                                <>
                                    <div>
                                        <div className="cuntrey-website pl-5 pr-5 pt-4 pb-1">
                                            <div className="cuntrey-website">
                                                {/* {timezoneOnly && ( */}
                                                <select
                                                    className="select-check"
                                                    value={value}
                                                    onChange={changeHandler}
                                                    id="timezone"
                                                    name="timezone"
                                                    placeholder="Select Your Timezone"
                                                >
                                                    <option disabled="" selected="" value="">
                                                        Timezone<i>*</i>
                                                    </option>
                                                    {newTimezoneData.map((timezone) => (
                                                        <option value={timezone.id}>
                                                            {timezone.front_name}
                                                        </option>
                                                    ))}
                                                </select>

                                                {error && <div className="error-select mb-1"> <span className="error">Required</span></div>}


                                            </div>
                                            {CurrentDate !== undefined && <div>
                                                <h6 className="mt-4 text-left">   Current time as per selected timezone: <b className="red ">{CurrentDates}</b></h6>
                                                <div className="full-fild">

                                                    <div className="prvacy-box eth-pri">
                                                        <input
                                                            onChange={(e) => settimeconfirmcheck(e.target.checked)}

                                                            value="The time above is my correct time"
                                                            id="timeconfirmcheck2"
                                                            type="checkbox"
                                                            name="timeconfirmcheck2"

                                                            className="pointer"
                                                        />
                                                        <label htmlFor="timeconfirmcheck2">
                                                            The time above is my correct time.
                                                        </label>
                                                        <span className="error error-select">

                                                            {!timeconfirmcheck && showRequiredError && <div className="error-select mb-1"> <span className="error">Required</span></div>}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </div>

                                    </div>
                                    <div className="text-center">
                                    <div
                                        className="advance-tag margin-unset pointer"
                                        onClick={submitHandler}
                                    >
                                        Submit
                                    </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
